import { HttpErrorResponse } from '@angular/common/http';
import { ErrorHandler, inject, Provider } from '@angular/core';

import { ErrorLoggerService } from '@ideals/services/error-logger';
import { LogRocketService } from '@ideals/services/logrocket';
import { SentryService } from '@ideals/services/sentry';
import { LOCATION } from '@ideals/types';
import { createUniqueId } from '@ideals/utils';

export const CHUNK_LOADING_ERRORS: RegExp[] = [
  /Loading chunk [\w-]+ failed/,
  /Failed to fetch dynamically imported module/,
];

export class CustomErrorHandler implements ErrorHandler {
  readonly #errorLoggerService = inject(ErrorLoggerService);
  readonly #location = inject(LOCATION);
  readonly #logRocketService = inject(LogRocketService);
  readonly #sentryService = inject(SentryService);

  handleError(error: Error | HttpErrorResponse): void {
    if (CHUNK_LOADING_ERRORS.some((chunkError) => chunkError.test(error.message))) {
      this.#location.reload();

      return;
    }

    if (error instanceof Error) {
      const errorId = createUniqueId();

      this.#errorLoggerService.handleJsError(error);
      this.#logRocketService.captureException(error);
      this.#sentryService.captureException(errorId, error);
    }
  }
}

export function provideErrorHandler(): Provider[] {
  return [
    {
      provide: ErrorHandler,
      useClass: CustomErrorHandler,
    },
  ];
}
